export const initialState = {
    is_loading: true,
    attachments: [],
    is_show_add_attachment_modal: false,
    uploaded_document: null,
    is_loading_save_btn: false,
    new_attachment_count:0
}